import React, {useEffect} from 'react'
import { Trans, useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'
import {useInjection} from 'dna-react-ioc'
import {Form, FormInstance} from 'antd'
import {FormItemVerificationCode} from '@/components'
import {TwoFAModalStoreInterface} from '@/stores/profile/TwoFAModalStore/TwoFAModalStoreInterface'
import {TwoFAModalStoreSymbol} from '@/pages/Profile/components/TwoFA/components/TwoFAModal'

import styles from './styles.scss'

export type TwoFAConfigureAuthAppProps = {
    form: FormInstance
}

export const TwoFAConfigureAuthApp: React.FC<TwoFAConfigureAuthAppProps> = observer(({form}) => {
    const { t } = useTranslation()
    const {authAppInfo, secretKey, qrCode} =
        useInjection<TwoFAModalStoreInterface>(TwoFAModalStoreSymbol)

    const {key, account} = secretKey

    useEffect(() => () => form.resetFields(), [])

    return (
        <div>
            <p>{t('TwoFAConfigureAuthApp.title')}</p>
            <ul className={styles.list}>
                <li>
                    1.{' '}
                    <Trans
                        i18nKey='TwoFAConfigureAuthApp.step1'
                        components={[
                            <a key='android' href={authAppInfo?.android?.google?.Url} target='_blank' rel="noreferrer" />,
                            <a key='ios' href={authAppInfo?.ios?.google?.Url} target='_blank' rel="noreferrer" />
                        ]}
                    />
                </li>
                <li>
                    2.{' '}
                    <Trans
                        i18nKey='TwoFAConfigureAuthApp.step2'
                        values={{ key, account }}
                        components={{ code: <code /> }}
                    />
                    <div className={styles.qrHolder}>
                        <img src={`data:image/jpeg;base64, ${qrCode}`} alt={'qrCode'} />
                    </div>
                </li>
                <li>3. {t('TwoFAConfigureAuthApp.step3')}</li>
                <li>
                    <Form form={form} className={styles.form}>
                        <FormItemVerificationCode className={styles.formItem} />
                    </Form>
                </li>
            </ul>
        </div>
    )
})
